import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from './messages';
import style from './upsell-banner.module.css';
import { PromotionalBanner } from '../../../../../../../components/promotional-banner';

/**
 * @typedef {import('../../../../../../../prop-types/intl').MessageDescriptorPropType} MessageDescriptor
 */

/**
 * UpsellBanner component that displays promotional content for bundles feature
 * Uses PromotionalBanner for consistent design system styling
 * @param {object} props
 * @param {() => void} props.onOpen - Function to handle button click action
 * @param {MessageDescriptor} props.subheaderMessage - The message object to display in the banner subheader
 * @param {MessageDescriptor} props.buttonMessage - The message object to display in the button
 * @returns {JSX.Element}
 */
export const UpsellBanner = ({ onOpen, subheaderMessage, buttonMessage }) => {
  return (
    <PromotionalBanner
      className={style['bundle-upsell-banner']}
      promotionalHeaderMessage={messages.upsellTitle}
      promotionalSubheaderMessage={subheaderMessage}
    >
      <Button onClick={onOpen} theme={THEME_CONSTANTS.promotional}>
        <FormattedMessage {...buttonMessage} />
      </Button>
    </PromotionalBanner>
  );
};
